module.exports = __webpack_public_path__ + "img/product-placeholder-84.a31042d.png";